import React, { FC, useEffect, useState, useRef } from 'react';
import {Dropdown, SelectOption} from '../components/dropdown/dropdown.component';

import {PageContentWrapper} from '../components/page-content-wrapper/page-content-wrapper.component';
import {PageHeader} from '../components/page-header/page-header.component';
import { PaginationButtons } from '../components/pagination-buttons/pagniation-buttons.component';
import {SearchField} from '../components/search-field/search-field.component';
import {VehicleListItem} from '../components/vehicle-list-item/vehicle-list-item.component';
import {useAccount} from '../contexts/AccountContext';
import {UnitDetail} from '../services/api/models/UnitDetail';

export const AccountList: FC = () => {
  const [dropdownOptions, setDropdownOptions] = useState<SelectOption[]>([]);

    const { units, accounts, selectActiveAccount, activeAccount, refreshing, page, pageLength, setPage, filter, setFilter } = useAccount();

  useEffect(() => {
    if (accounts && accounts.length > 1) {
      let options: SelectOption[] = [];
      for (let i = 0; i < accounts.length; i++) {
        if (accounts[i].id && accounts[i].name) {
          options.push({value: accounts[i].id || 0, label: accounts[i].name});
        }
      }
      setDropdownOptions(options);
    }
  }, [accounts]);

    //the useRef Hook allows you to persist data between renders
    const prevAccountRef = useRef(activeAccount);
    useEffect(() => {
        //assign the ref's current value to the count Hook
        prevAccountRef.current = activeAccount;
    }, [activeAccount]); //run this code when the value of count changes

  const onAccountSelected = (option: SelectOption) => {
    if (!option) {
      selectActiveAccount(null);
      return;
    }
    const account = accounts.find(acc => {
      return acc.id === option.value;
    });
      setPage(1)
      setFilter('');
    selectActiveAccount(account || null);
  };

  const getFilteredUnits = (filter: string): UnitDetail[] => {
     
      return units;
     

    //return units.filter(u => u.unitName?.toLowerCase().includes(filter.toLowerCase()) || u.simNumber?.toLowerCase().includes(filter.toLowerCase()));
  };

  return (
    <div className="flex flex-1 flex-col relative">
      <PageHeader title="Vehicle List" />
      <div className="flex flex-1">
        <PageContentWrapper>
          <div className="flex flex-col gap-2">
                      {accounts ? (
                          <div>
                              <Dropdown
                                values={dropdownOptions}
                                onSelect={onAccountSelected}
                                initialValue={activeAccount || undefined}
                                label={(!activeAccount && 'Select an account to continue') || ''}
                                              />

                                          </div>
                         ) : (
                          <h2>Accounts not found</h2>
                        )
                      }

                      {refreshing && filter =='' ? ( //Reset filter text on account change
                          <h3></h3>
                      ) :(


                              <SearchField
                                  placeholder="Friendly name or VRN"
                                  onChange={s => {
                                      setPage(1)
                                      setFilter(s.toLowerCase());

                                  }}
                              />)
                      }

            {refreshing ? (
              <h3>Loading vehicles...</h3>
            ) : (
              activeAccount && (
                <>

                  {units ? (
                    units.map((v, i) => {
                      return <VehicleListItem unit={v} key={i} searchFilter={filter} />;
                    })
                  ) : (
                    <h3>No Assets assigned.</h3>
                                      )}
                                      {
                                          pageLength > 1 && <PaginationButtons numPages={pageLength} selected={page} onPress={setPage} startingPage={1} />

                                      }
                </>
              )
            )}
          </div>
        </PageContentWrapper>
      </div>
    </div>
  );
};
